<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.fsCooperationDt" style="width: 140px;" size="small" placeholder="请输入协作部门"
                        clearable></el-input>
                    <el-input v-model="formDatas.fsCustomerUnit" style="width: 140px;" size="small"
                        placeholder="请输入甲方单位" clearable></el-input>
                    <el-input v-model="formDatas.fsUser" style="width: 140px;" size="small" placeholder="请输入负责人"
                        clearable></el-input>
                    <el-input v-model="formDatas.fsUserDt" style="width: 140px;" size="small" placeholder="请输入主做部门"
                        clearable></el-input>
                    <el-select v-model="formDatas.fsFilesStatus" size="small" clearable placeholder="请选择是否有大文件"
                        style="width: 130px" @change="partserch">
                        <el-option label="否" :value="1" key="1"></el-option>
                        <el-option label="是" :value="2" key="2"></el-option>
                    </el-select>
                    <el-select v-model="formDatas.fsFilesStatusDing" size="small" clearable placeholder="请选择上传钉盘状态"
                        style="width: 130px" @change="partserch">
                        <el-option label="未上传" :value="1" key="1"></el-option>
                        <el-option label="已上传" :value="2" key="2"></el-option>
                    </el-select>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="fsId"
                        :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>

            <!-- 详情 -->
            <el-dialog title="详情" :visible.sync="IsDetail" width="70%" top="8vh">


                <div style="max-height: 500px; overflow-y: scroll">
                    <el-descriptions :column="3" border :labelStyle="{
                        color: '#409EFF',
                        textAlign: 'center',
                        width: '14%',
                        fontSize: '12px'
                    }" :contentStyle="{ textAlign: 'center', width: '18%', fontSize: '12px' }">
                        <el-descriptions-item label="行程名称">{{ DetailArr.fsCooperationDt }}</el-descriptions-item>
                        <el-descriptions-item label="客户名称">{{ DetailArr.fsCustomerUnit }}</el-descriptions-item>
                        <el-descriptions-item label="负责人">{{ DetailArr.fsUser }}</el-descriptions-item>
                        <el-descriptions-item label="主做部门">{{ DetailArr.fsUserDt }}</el-descriptions-item>
                        <el-descriptions-item label="备注">{{ DetailArr.fsWorkDes }}</el-descriptions-item>
                    </el-descriptions>
                    <p style="margin: 10px;">大文件列表:</p>
                    <el-row style="margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                        <el-button type="warning" size="small" style="margin-right: 10px;"
                            @click="DownDd(DetailArr)">下载文件到钉盘</el-button>
                    </el-row>
                    <el-table :data="DetailArr.fxxkFileList" border highlight-current-row :header-cell-style="{
                        textAlign: 'center',
                        background: 'rgba(0,170,255,0.5)',
                        color: 'black',
                        border: 'none'
                    }" style="width: 100%;margin:12px 0 0 0;">
                        <el-table-column label="文件名" align="center" prop="filename">
                        </el-table-column>
                        <el-table-column label="类型" align="center" prop="ext">
                        </el-table-column>
                        <el-table-column label="地址" align="center" prop="ffPathLocal">
                        </el-table-column>
                        <el-table-column label="文件大小" align="center" prop="sizeStr">
                        </el-table-column>
                        <el-table-column label="创建时间" align="center" prop="ffCreateTimeStr">
                        </el-table-column>
                        <el-table-column label="状态" align="center" prop="ffCreateTimeStr">
                            <template slot-scope="scope">
                                <el-tag>
                                    {{ scope.row.ffStatus == 1 ? '未下载' : scope.row.ffStatus == 2 ? '已下载'
                        : scope.row.ffStatus == 3 ? '下载失败' : scope.row.ffStatus == 4 ? '未上传'
                            : scope.row.ffStatus == 5 ? '已上传' : '上传失败' }}
                                </el-tag>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>

import { getFxxkSupportList, addAjPurchasePublicItem, updateAjPurchasePublicItem, deleteAjPurchasePublicItem, getFxxkSupportDetails, updateFxxkSupportFilesDesStatus } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            IsDetail: false,
            DetailArr: '',
            key: 'fsId',
            dialog: false,
            edit: false,
            form: {
                appiName: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "fsCustomerUnit",
                    key: "fsCustomerUnit",
                    title: "甲方单位",
                    align: "center",
                    edit: false,
                    fixed: 'left',
                    width: 300,
                },
                
                {
                    field: "fsUserDt",
                    key: "fsUserDt",
                    title: "主做部门",
                    align: "center",
                    edit: false,
                    fixed: 'left',
                    width: 150,
                },
                {
                    field: "fsFilesStatus",
                    key: "fsFilesStatus",
                    title: "是否有大文件(1否 2是)",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "fsFilesStatusDing",
                    key: "fsFilesStatusDing",
                    title: "上传钉盘状态(1未 2已)",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                { field: "fsCreateTimeStr", key: "cc", title: "纷享创建时间", width: 160, align: "center" },
                
                {
                    field: "fsUser",
                    key: "fsUser",
                    title: "负责人",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "fsCooperationDt",
                    key: "fsCooperationDt",
                    title: "协作部门",
                    align: "center",
                    edit: false,
                    width: 200,
                },
                {
                    field: "fsWorkDes",
                    key: "fsWorkDes",
                    title: "备注",
                    align: "center",
                    edit: false,
                    width: 400,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 3,
                    },
                },
               
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 100,
                    align: "center",
                    fixed: 'right',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.handleDetail(row)}
                                >
                                    详情
                                </el-button>

                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                fsFilesStatusDing:'',
                fsCooperationDt: '',
                fsCustomerUnit: '',
                fsUser: '',
                fsUserDt: '',
                fsFilesStatus: '',
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
    },
    mounted() { },
    methods: {
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        DownDd(val) {
            this.openLoading()
            updateFxxkSupportFilesDesStatus({ fsId: val.fsId }).then(res => {
                if (res.data) {
                    this.loadings.close()
                    getFxxkSupportDetails({ fsId: val.fsId }).then(ress => {
                        this.DetailArr = ress.data;
                        this.$message({
                            type: "success",
                            message: "下载成功!",
                        });
                    })
                }else{
                    this.loadings.close()
                }
            }).catch(err=>{
                if(err){
                    this.loadings.close()
                }
            })
        },
        handleDetail(row) {
            getFxxkSupportDetails({ fsId: row.fsId }).then(res => {
                this.DetailArr = res.data;
                this.IsDetail = true;
                console.log(this.DetailArr);
            })
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        deleteAjPurchasePublicItem({ fsIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });

                                this.partserch()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteAjPurchasePublicItem({ fsIds: row.fsId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addAjPurchasePublicItem(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjPurchasePublicItem(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.fsId = row.fsId
                    console.log(jsonObj);
                    updateAjPurchasePublicItem(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getFxxkSupportList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getFxxkSupportList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getFxxkSupportList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>